import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { TemplateEditPage } from './TemplateEditPage'
import { TemplatesPage } from './TemplatesPage'

export const routes: RouteObject[] = [
  { path: '/templates', element: <TemplatesPage /> },
  { path: '/templates/:id', element: <TemplateEditPage /> },
]

export const nav: NavItem[] = [{ path: '/templates', label: 'Шаблоны', icon: 'list', mobile: 'more', order: 42 }]
